import Service from "../../Services";

const OnlineExhibition = {
  namespaced : true,
  state : {
    form : {
      branch_id : '',
      title_th : '',
      title_en : '',
      detail_en : '',
      detail_th : '',
      cover_image : '',
      cover_image_path : '',
      cover_image_name : '',
      slug_url : '',
      attached_website : '',
      template_id : '',
      publish_date : '',
      background_color : '',
      viewer : '',
      is_publish : true,
    }
  },
  mutations : {
    GET_FORM:(state,res)=>{
     state.form = res;
    },
    CLEAR_FORM_DATA :(state)=>{
      state.form = {
        branch_id : '',
        title_th : '',
        title_en : '',
        detail_en : '',
        detail_th : '',
        cover_image : '',
        cover_image_path : '',
        cover_image_name : '',
        slug_url : '',
        attached_website : '',
        template_id : '',
        publish_date : '',
        background_color : '',
        viewer : '',
        is_publish : true,
      }
    }
  },
  actions : {
    getOnlineExhibition({commit},page){
      return Service.OnlineExhibitionAPI.getOnlineExhibition(page);
    },
    showOnlineExhibition({commit},id){
      return Service.OnlineExhibitionAPI.showOnlineExhibition(id);
    },
    saveOnlineExhibition({commit},{id,data}){
      if(id){
        return Service.OnlineExhibitionAPI.updateOnlineExhibition(id,data);
      }else{
        return Service.OnlineExhibitionAPI.createOnlineExhibition(data);
      }
    },
    deleteOnlineExhibition({commit},id){
      return Service.OnlineExhibitionAPI.deleteOnlineExhibition(id);
    },
    setFormOnlineExhibition({commit},res){
      commit('GET_FORM',res);
    },
    clearFormData({commit}){
      commit('CLEAR_FORM_DATA');
    }
  },
}
export default OnlineExhibition
